import { AuthorizationActions } from '../userAccount/actionNames'
import initialStore from './initialState'
import { IntegrationAction } from './actionNames'
import { TListing } from '../../models/Integration/request/handleResponse'
import { IAirbnbPriceGridData } from '../../models/Integration/fetchAirbnbPrices'
import { RoomActions } from '../bookingCalendar/actionNames'

export enum IntegrationStatus {
  NotIntegrated,
  Integrated,
}

export default function(
  store: Readonly<IIntegrationStore> = initialStore,
  action: any,
): IIntegrationStore {
  switch (action.type) {
    case IntegrationAction.SetIntegration:
      return {
        ...store,
        status: action.payload,
        checked: true,
        loadingListings:
          action.payload === IntegrationStatus.NotIntegrated
            ? false
            : store.loadingListings,
      }
    case IntegrationAction.AcceptListings:
      return {
        ...store,
        listings: action.payload,
        loadingListings: false,
      }
    case IntegrationAction.SetTab:
      return {
        ...store,
        tab: action.payload,
      }
    case IntegrationAction.SetPriceTab:
      return {
        ...store,
        priceTab: action.payload,
      }
    case IntegrationAction.AcceptDeleteListing:
      return {
        ...store,
        listings: store.listings.map(l =>
          l.id === action.payload.id_listing
            ? { ...l, bedbooking_id_room: 0 }
            : l,
        ),
      }
    case IntegrationAction.AcceptCreateListing:
      return {
        ...store,
        listings: store.listings.map(l =>
          l.id === action.payload.id_listing
            ? { ...l, bedbooking_id_room: action.payload.id_room }
            : l,
        ),
      }
    case IntegrationAction.ToggleNotAllModal:
      return {
        ...store,
        notConnectedModal: action.payload,
      }
    case IntegrationAction.AcceptFetchPrice:
      return {
        ...store,
        prices: action.payload,
        loadingPrice: false,
      }
    case IntegrationAction.SetSync:
      return {
        ...store,
        sync: action.payload,
      }
    case IntegrationAction.SubmitPriceForm:
      return {
        ...store,
        loadingPrice: true,
      }
    case IntegrationAction.SetLoadingPrice:
      return {
        ...store,
        loadingPrice: action.payload,
      }
    case IntegrationAction.FetchRoomConfiguration:
      return {
        ...store,
        loadingConfiguration: true,
      }
    case IntegrationAction.ToggleConfigurationLoading:
      return {
        ...store,
        loadingConfiguration: action.payload,
      }
    case IntegrationAction.ToggleSavingConfiguration:
      return {
        ...store,
        savingConfiguration: action.payload,
      }
    case IntegrationAction.RoomConfigurationAccepted:
      return {
        ...store,
        configuration: action.payload,
        loadingConfiguration: false,
      }
    case RoomActions.RoomWasDeleted: {
      return {
        ...store,
        listings: store.listings.map(l =>
          String(l.bedbooking_id_room) === String(action.roomId)
            ? { ...l, bedbooking_id_room: 0 }
            : l,
        ),
      }
    }
    case IntegrationAction.SetAirbnbAgreement:
      return {
        ...store,
        agreement: action.payload,
      }

    case IntegrationAction.GetListings:
      return {
        ...store,
        loadingListings: true,
      }
    case IntegrationAction.SetAirbnbBackdrop:
      return {
        ...store,
        backdrop: action.payload,
      }
    case IntegrationAction.SetBookingPropertyModalStep:
      return {
        ...store,
        step: action.payload,
      }
      case IntegrationAction.SetBookingPropertyModalConfirmStep:
      return {
        ...store,
        confirmStep: action.payload,
      }
      case IntegrationAction.ToggleBookingPropertyConfirmModal:
      return {
        ...store,
        confirmModal: action.payload,
      }
    case AuthorizationActions.FlushState:
      return { ...initialStore }
  }

  return store
}

export enum IntegrationSync {
  NotSyncing,
  Syncing,
}

export interface IIntegrationStore {
  status: IntegrationStatus
  checked: boolean
  listings: TListing[]
  tab: number
  sync: IntegrationSync
  priceTab: number
  notConnectedModal: boolean
  prices: IAirbnbPriceGridData[]
  loadingPrice: boolean
  savingConfiguration: boolean
  loadingConfiguration: boolean
  configuration: any
  loadingListings?: boolean
  agreement: boolean
  backdrop: boolean
  step: number
  confirmStep: number
  confirmModal: boolean
}
